import React from "react";

import { Link } from "react-router-dom";

import { Divider, Table, Popconfirm, Button, Alert, Space, Tooltip } from "antd";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { DeleteOutlined, DownloadOutlined, PlusOutlined, EditOutlined, PlusCircleTwoTone } from "@ant-design/icons";
import Moment from "moment";
import { DATE_FORMAT } from "../../../../../core/utils/i18n-js";
import { expandPurchaseOrderDetailsFromInvoiceDetail } from "../../../../../components/job/finance/invoiceDetails";
import { AmountText } from "../../../../../core/components/widget/amountInline";
import StatisticAmount from "../../../../../core/components/widget/amountInline/statistic";

import { LAYOUT_MANAGER_JOB_SHOW } from "../../../../manager/navigation";
import { LAYOUT_FINANCE_INVOICE_CLIENT_ADD_JOB } from "../../../navigation";

import FormRectification from "../rectification";
import { sub, round } from "../../../../../core/utils/currency";

const INVOICE_TYPE_PURCHASE_ORDER = "PURCHASE ORDER";

const columnsAntd = (props, showRectificationForm) => {
    const { servicesById, loading, removeJobFromInvoiceClient, data, actionLoading, allowEdit } = props;

    if (loading) {
        return [];
    }

    const columns = [
        {
            title: "Job",
            dataIndex: "job",
            doctrineKey: "j.id",
            key: "job",
            fixed: "left",
            width: 100,
            sorter: (a, b) => {
                return a.job.id > b.job.id;
            },
            render: (job, record) => <Link to={LAYOUT_MANAGER_JOB_SHOW(job?.id)}>J-{job?.id}</Link>,
        },
        {
            title: "E-ID #",
            dataIndex: "job",
            doctrineKey: "j.eid",
            key: "job",
            width: 150,
            sorter: (a, b) => {
                return a.job.eid > b.job.eid;
            },
            render: (job, record) => <>{job.eid}</>,
        },
        /*
        {
            title: "Receivable Code",
            dataIndex: "job",
            doctrineKey: "j.code",
            width: 150,
            key: "job",
            sorter: (a, b) => {
                return a.job.code > b.job.code;
            },
            render: (job, record) => <>{job.code}</>,
        },*/
        {
            title: "Name",
            dataIndex: "job",
            doctrineKey: "j.name",
            key: "job",
            ellipsis: true,
            sorter: (a, b) => {
                return a.job.name > b.job.name;
            },
            render: (job, record) => <>{job.name}</>,
        },
        {
            title: "Finance Date",
            dataIndex: "job",
            key: "j.financeDate",
            doctrineKey: "j.financeDate",
            width: 150,
            sorter: (a, b) => {
                return a.job.financeDate > b.job.financeDate;
            },
            render: (job) => {
                if (job && job.financeDate) return <>{Moment(job.financeDate).format(DATE_FORMAT)}</>;
            },
        },

        {
            title: "Amount",
            dataIndex: "amountValue",
            key: "amountValue",
            width: 150,
            sorter: (a, b) => {
                return a.amountValue - b.amountValue;
            },
            doctrineKey: "pt.amountValue",
            // eslint-disable-next-line react/display-name
            render: (jsa, record) => <AmountText value={record.amountValue} type={record.amountType} />,
        },
    ];

    columns.push({
        title: "Valid",
        key: "validated",
        width: 80,
        sorter: (a, b) => {
            //Uncompensated value for JobA
            const ret1 = Math.abs(sub(a.job.totalToReceiveValue, a.job.balanceClient));

            //Uncompensated value for JobB
            const ret2 = Math.abs(sub(b.job.totalToReceiveValue, b.job.balanceClient));

            return ret1 == ret2 ? 0 : ret1 > ret2 ? 1 : -1;
        },
        sortDirections: ["descend"],
        defaultSortOrder: "descend",
        render: (record) => {
            if (record.job.balanceClient == record.job.totalToReceiveValue) {
                return <CheckCircleTwoTone twoToneColor="#52c41a" />;
            } else {
                return (
                    <Tooltip title={sub(record.job.totalToReceiveValue, record.job.balanceClient)}>
                        <CloseCircleTwoTone twoToneColor="#eb2f96" />
                    </Tooltip>
                );
            }
        },
    });

    columns.push({
        title: "Action",
        key: "action",
        width: 280,
        render: (text, record) => (
            <Space>
                {" "}
                {allowEdit && !hasRectification(record, data.jobs) && (
                    <>
                        <Popconfirm
                            title="Are you sure?"
                            onConfirm={() => removeJobFromInvoiceClient(data.invoice.id, record.id)}
                            okText="Yes"
                            cancelText="No"
                            disabled={actionLoading}
                        >
                            <Button icon={<DeleteOutlined />} size="small">
                                Remove
                            </Button>
                        </Popconfirm>
                        <>
                            <Divider type="vertical" />
                            <Button
                                icon={<EditOutlined />}
                                size="small"
                                onClick={() => showRectificationForm(record)}
                                disabled={actionLoading}
                            >
                                Rectificate
                            </Button>
                        </>
                    </>
                )}
            </Space>
        ),
    });

    return columns;
};

const getMaybeJob = (invoiceDetail, jobs) => {
    const jobId = invoiceDetail.jobId;
    const maybeJob = jobs.filter((j) => j.id == jobId);

    if ((maybeJob || []).length === 1) {
        const job = maybeJob[0];
        return job;
    }

    return false;
};

const hasRectification = (invoiceDetail, jobs) => {
    const job = getMaybeJob(invoiceDetail, jobs);

    if (job) {
        return job.receivables.some((p) => p.rectification);
    }

    return false;
};

/**
 *
 */
export default class Show extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalRectificationVisible: false,
            invoiceDetailId: 0,
        };
    }
    _goBack = () => {
        this.props.history.goBack();
    };

    showRectificationForm = (invoiceDetail) => {
        this.setState({
            modalRectificationVisible: true,
            invoiceDetailId: invoiceDetail.id,
            rectificationAmount: invoiceDetail.amountValue,
        });
    };

    render() {
        const {
            data,
            includeRectificationInvoiceClient,
            deleteRectificationInvoiceClient,
            actionLoading,
            allowEdit,
            download,
            downloadExport,
        } = this.props;

        const expandedRowClassName = (record, index, indent) => "table-finance-details";

        const expandedRowRender = (record) => {
            if ((record.purchaseOrderDetails || []).length > 0) {
                return (
                    <>
                        {expandPurchaseOrderDetailsFromInvoiceDetail(record)}
                        {hasRectification(record, data.jobs) && displayRectifaction(data.invoice.id, record)}
                    </>
                );
            }

            /*
            if (hasRectification(record, data.jobs)) {
                return displayRectifaction(data.invoice.id, record);
            }*/

            return null;
        };

        const displayRectifaction = (invoiceId, invoiceDetail) => {
            const job = getMaybeJob(invoiceDetail, data.jobs);
            if (job === false) {
                return;
            }

            const rectification = job.receivables.find((p) => p.rectification);
            rectification["invoiceId"] = rectification.invoice ? rectification.invoice.id : 0;
            if (invoiceId === rectification.invoiceId) {
                // correccion no incluida en la misma PO
                return (
                    <Alert
                        showIcon
                        message={
                            "This job has a rectification of " +
                            rectification.subtotalValue +
                            " included is this Invoice"
                        }
                        type="success"
                        action={
                            allowEdit && (
                                <Button
                                    onClick={() => deleteRectificationInvoiceClient(invoiceId, invoiceDetail.id)}
                                    size="small"
                                    disabled={actionLoading}
                                >
                                    Delete
                                </Button>
                            )
                        }
                    />
                );
            }
        };

        return (
            <>
                <Space>
                    {data.invoice.fileId && (
                        <Button type="default" onClick={() => downloadExport(data.invoice.fileId, "PO")} size="small">
                            <DownloadOutlined />
                            <Divider type="vertical" />
                            Download PO
                        </Button>
                    )}
                </Space>

                <br />
                <br />
                <Table
                    pagination={false}
                    bordered={true}
                    size="small"
                    rowKey={(row) => row.id}
                    dataSource={data.invoice.details}
                    columns={columnsAntd(this.props, this.showRectificationForm)}
                    expandable={{
                        expandedRowClassName,
                        rowExpandable: (record) => true,
                        expandedRowRender: expandedRowRender,
                    }}
                />

                {this.state.modalRectificationVisible && (
                    <FormRectification
                        visible={this.state.modalRectificationVisible}
                        handleCancel={() => {
                            this.setState({ modalRectificationVisible: false, rectificationAmount: null });
                        }}
                        purchaseOrder={true}
                        invoiceId={data.invoice.id}
                        invoiceDetailId={this.state.invoiceDetailId}
                        rectificationAmount={this.state.rectificationAmount}
                    />
                )}
            </>
        );
    }
}
